export const SET_ONLOADING = 'SET_ONLOADING';
export const SET_CURRENT_FLOW = 'SET_CURRENT_FLOW';
